import {observable, action, runInAction, computed} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {ValueObjToObj, objToValueObj, setStore, handleSeerchAndPage} from '../../../../utils/Utils'
import {message} from "antd";

class FaultCaseFaultMaintenanceStore {

    @observable loading
    @observable list //目录
    @observable page //车系分页
    @observable importReturnData //导入返回值
    @observable showDrawer
    @observable editFields //新增修改数据
    @observable option
    @observable optionModal
    @observable addBoxModal
    @observable search //查询
    @observable upLoading //上传图标
    @observable imageUrl //上传图标

    constructor() {
        this.loading = false
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.importReturnData = []
        this.showDrawer = false
        this.editFields = {}
        this.option = []
        this.optionModal = ''
        this.addBoxModal = false
        this.search = {
            name: ''
        }
        this.upLoading=false
        this.imageUrl=''
    }

    /** 设置store对象，类似react的setState **/
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /** 初始化页面 **/
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchResult = handleSeerchAndPage(page, this.page, this.search) //多条件分页的轮子
        searchResult.size = this.page.pageSize
        searchResult.name = this.search.keyOrValue
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/directoryList`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /** 开启抽屉 **/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /** 关闭抽屉 **/
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /** 新增修改开启模态框 **/
    @action
    showBox = (record, option) => {
        runInAction(() => {
            if (option === 'update') {
                this.editFields = objToValueObj(record)
                this.imageUrl=record.imageUrl
            } else {
                this.editFields = {}
                this.imageUrl=''
            }
            this.loading = true
            this.option = option
            this.optionModal = option === 'addSame' ? '新增' : '修改'
            this.addBoxModal = true
            this.loading = false
        })
    }

    @computed
    get fields() {
        let fields = {
            name: {value: this.editFields.name},
            annotation: {value: this.editFields.annotation},
        }
        return fields
    }

    //Cast
    @action
    onEditFieldChange(changedFields) {
        this.editFields = {...this.editFields, ...changedFields}
    }

    /** 新增/修改 **/
    @action
    operation = async () => {
        this.loading = true
        if (this.option === 'addSame') {//添加
            let search = {
                name: this.editFields.name ? this.editFields.name.value : '',
                annotation: this.editFields.annotation ? this.editFields.annotation.value : '',
                imageUrl:this.imageUrl ? this.imageUrl :''
            }
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/addCatalog`, search)
            if (res && res.status === 0) {
                message.warning('该目录已存在，请勿重新添加!')
                this.loading = false
                return
            }
            message.success(`新增成功！`)
        } else if (this.option === 'update') {//修改
            let obj = {...ValueObjToObj(this.editFields),  imageUrl:this.imageUrl ? this.imageUrl :''}
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/update`,obj)
            if (res.status) {
                message.success(`修改成功！`)
            } else {
                message.warning(`该目录已存在，请勿重新添加!`)
            }
        }
        runInAction(() => {
            this.loading = false
            this.initListPage()
        })
    }

    /** 删除 **/
    @action
    deleteOne = async (record) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseFault/delById/id/${record.id}`)
        runInAction(() => {
            message.success(`删除成功！`)
            this.initListPage()
        })
    }

    /** 将页面的值绑定到store，查询值 **/
    @action
    onSearchFieldChange=(changedFields)=>{
        this.search={...this.search,...ValueObjToObj(changedFields)}
    }


    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        if (info.file.status === 'uploading') {
            runInAction(() => {
                this.upLoading = true
            })
            return
        }
        if (info.file.status === 'done') {
            runInAction(() => {
                this.imageUrl =info.file.response
                this.upLoading = false
            })
            return
        }
        if (info.file.status === 'error') {
            runInAction(() => {
                this.upLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }
}

export default new FaultCaseFaultMaintenanceStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/FaultDiagnosis/FaultCaseFaultMaintenance/store.js